import { Absolute, Box, Flex, Relative, Text } from 'pcln-design-system'
import React from 'react'
import styled from 'styled-components'
import AirlineImage from '../AirlineImage'

const StyledDollarSign = styled(Text)`
  align-self: flex-start;
  margin-top: -1px;
  margin-right: 2px;
`

const Wrapper = styled(Relative)`
  display: flex;
  justify-content: space-evenly;
`

const Line = styled(Absolute)`
  height: 2px;
  width: 100%;
`

const ImageWrapper = styled(Flex)`
  align-items: flex-end;
  height: 36px;
  width: 44px;
`

const AirlineWrapper = styled(Flex)`
  ${(props) => props.theme.mediaQueries.sm} {
    margin: 0 12px 0 12px;
  }
`

const StyledAirlineImage = styled(AirlineImage)`
  width: 32px;
  max-height: 36px;
`

const AirlineText = styled(Text)`
  ${(props) => props.theme.mediaQueries.sm} {
    padding-top: 4px;
  }
`

const LayoverText = styled(Text)`
  text-align: center;
  line-height: 16px;
  font-size: 10px;
  white-space: nowrap;
  ${(props) => props.theme.mediaQueries.lg} {
    font-size: 12px;
  }
`

const Dot = styled(Box)`
  margin-top: 2px;
  height: 5px;
  width: 5px;
  border-radius: 50%;
  @media screen and (min-width: 375px) {
    margin-top: 0px;
    height: 7px;
    width: 7px;
  }
`

const SimplifiedItinerary = ({ tripType, dollars, departing, arrival, duration, airline, strikePrice }) => (
  <Flex alignItems='center'>
    <Flex flexDirection='column' width={1} pb={0}>
      <Flex alignItems='center'>
        {airline && (
          <AirlineWrapper flexDirection='column' alignItems='center' mr={[1, '6px']}>
            <ImageWrapper justifyContent='center'>
              <Box>
                <StyledAirlineImage airlineName={airline.name} airlineLogo={airline.image} />
              </Box>
            </ImageWrapper>
            <AirlineText fontSize={'10px'} textAlign='center' color='text.light' mt={1}>
              {airline.name}
            </AirlineText>
          </AirlineWrapper>
        )}
        <Flex flexDirection='column' width={1}>
          <Flex>
            <Box data-testid='departure-box'>
              <Text
                bold
                fontSize={['14px', '16px']}
                mb={1}
                textAlign='right'
                data-testid='departure-time'
                color='text'
              >
                {departing.time}
              </Text>
              <Text fontSize={0} textAlign='right'>
                <Text.span p='1px' data-testid='departure-airport' color='text'>
                  {departing.airport}
                </Text.span>
              </Text>
            </Box>
            <Wrapper width={1} ml={2} mr={2}>
              <Line bg='border.base' top={20} color='text' />
              <Relative>
                <LayoverText fontSize={0} color='text' mb='1px' data-testid='layover-airport'>
                  {duration}
                </LayoverText>
                <Dot bg={'text.light'} m='auto' />
              </Relative>
            </Wrapper>
            <Box data-testid='arrival-box' minWidth='64px'>
              <Flex mb={1}>
                <Text bold fontSize={['14px', '16px']} data-testid='arrival-time' color='text'>
                  {arrival.time}
                </Text>
              </Flex>
              <Text fontSize={0} width='40px'>
                <Text.span p='1px' data-testid='arrival-airport' color='text'>
                  {arrival.airport}
                </Text.span>
              </Text>
            </Box>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
    <Box textAlign='center'>
      {strikePrice && <Text.s fontSize={0} fontWeight='bold' textAlign='center'>{`$${strikePrice}`}</Text.s>}
      <Text fontSize={0} fontWeight='bold' textAlign='center'>
        {strikePrice ? 'now only' : 'as low as'}
      </Text>
      <Flex minWidth='80px' justifyContent='center' my={1}>
        <Box data-autobot-element-id='GREEN_DISPLAY_PRICE'>
          <Text color='secondary'>
            <Flex data-testid='display-price' justifyContent='flex-end' alignItems='center'>
              <StyledDollarSign fontSize={0} fontWeight='bold'>
                $
              </StyledDollarSign>
              <Text lineHeight={1} fontWeight='bold' fontSize={3}>
                {dollars}
              </Text>
            </Flex>
          </Text>
        </Box>
      </Flex>
      <Text color='text.light' fontSize='10px' textAlign='center'>
        {tripType}
      </Text>
    </Box>
  </Flex>
)

export default SimplifiedItinerary
